//NPM LIBRARIES
import React, {Component} from 'react';
import PropTypes from 'prop-types';

const directions = {
    up: 'au-direction-link__arrow--up',
    right: 'au-direction-link__arrow--right',
    down: 'au-direction-link__arrow--down',
    left: 'au-direction-link__arrow--left',
};

class CustomBackLink extends Component {
    constructor(props) {
        super(props);

    }

    keyPressEvent = (event) => {
        event.preventDefault();
        if (event.which === 13 || event.keyCode === 13) {
            this.props.action(event);
        }
    }

    getSpantag = () => {
        if (this.props.direction === "left") {
            return (
                <React.Fragment>
                    <span className={`au-direction-link__arrow ${directions[this.props.direction]} `} aria-hidden="true"></span>
                    {this.props.text}
                </React.Fragment>

            )
        } else {
            return (
                <React.Fragment>
                    {this.props.text}
                    <span className={`au-direction-link__arrow ${directions[this.props.direction]}`} aria-hidden="true"></span>
                </React.Fragment>
            )
        }
    }

    render() {
        return (
            <div className={ `au-direction-link ${ this.props.className } ${ this.propsdark ? ' au-direction-link--dark' : '' }`}
                 tabIndex="0"
                 onClick={(event) => this.props.action(event)}
                 onKeyPress={(event) => this.keyPressEvent(event)}
                 { ...this.props } >
                {this.getSpantag()}
            </div>
        )
    }
}


CustomBackLink.propTypes = {
    direction : PropTypes.string,
    text : PropTypes.string,
    className : PropTypes.string,
    action : PropTypes.func
};

export default CustomBackLink;